import { PermissionsByBetaStatus } from '../types';

interface ExtractPermissionByBetaStatusParams {
  isBetaUser: boolean;
  permissionsByBetaStatus: PermissionsByBetaStatus;
}

export function extractPermissionByBetaStatus({
  isBetaUser,
  permissionsByBetaStatus,
}: ExtractPermissionByBetaStatusParams) {
  const { release, beta } = permissionsByBetaStatus;
  if (!beta) return release;

  return isBetaUser ? beta : release;
}
